import React from "react";
import { Card, CardBody, CardHeader, Col } from "reactstrap";

const PrivacyPolicy = () => {
  return (
    <Col lg="8" md="10">
      <Card className="bg-secondary shadow border-0">
        <CardHeader className="bg-transparent">
          <h2 className="mb-0">Gizlilik Politikası</h2>
          <p className="text-muted mb-0">
            Yürürlük tarihi: 6 Şubat 2026
          </p>
        </CardHeader>
        <CardBody className="px-lg-5 py-lg-5 text-muted">
          <p>
            Bu Gizlilik Politikası, Destination Black Sea - Karadeniz Destinasyonu
            portalını ("Portal") kullandığınızda hangi verileri işlediğimizi,
            bu verileri hangi amaçlarla kullandığımızı ve haklarınızı açıklar.
          </p>

          <h4 className="mt-4">1) Hangi verileri işliyoruz?</h4>
          <ul>
            <li>
              <strong>Kimlik/iletişim:</strong> Telefon numarası (SMS doğrulama
              ile), isteğe bağlı e-posta, ad-soyad gibi profil alanları.
            </li>
            <li>
              <strong>Hesap bilgileri:</strong> Kullanıcı kimliği (UID),
              oturum/sağlayıcı bilgisi (telefon, Facebook, Google).
            </li>
            <li>
              <strong>Kullanım/teknik:</strong> Hata kayıtları, tarayıcı bilgisi,
              cihaz ve oturum verileri (güvenlik ve hizmet kalitesi için).
            </li>
          </ul>

          <h4 className="mt-4">2) Verileri hangi amaçlarla kullanıyoruz?</h4>
          <ul>
            <li>Hesap oluşturma, giriş ve kimlik doğrulama işlemleri</li>
            <li>Hizmeti sunma, sürdürme ve geliştirme</li>
            <li>Güvenlik, suistimal önleme ve hata ayıklama</li>
            <li>Mevzuata uyum ve yasal yükümlülüklerin yerine getirilmesi</li>
          </ul>

          <h4 className="mt-4">3) Veri paylaşımı</h4>
          <p>
            Portal, kimlik doğrulama ve veri saklama altyapısı için üçüncü taraf
            hizmet sağlayıcılar kullanabilir (örn. Firebase/Google). Bu
            sağlayıcılar, hizmetin çalışması için gerekli olduğu ölçüde ve kendi
            sözleşmeleri/gizlilik politikaları kapsamında veri işleyebilir.
          </p>

          <h4 className="mt-4">4) Saklama süresi</h4>
          <p>
            Verilerinizi, Portal’ı sağlamak için gerekli olduğu süre boyunca ve
            ilgili mevzuatın gerektirdiği süreler boyunca saklayabiliriz. Hesabın
            kapanması veya talebiniz doğrultusunda, saklama yükümlülükleri saklı
            kalmak kaydıyla silme/anonimleştirme işlemleri yapılabilir.
          </p>

          <h4 className="mt-4">5) Güvenlik</h4>
          <p>
            Verilerin korunması için makul teknik ve idari önlemler uygularız.
            Ancak internet üzerinden yapılan hiçbir aktarımın %100 güvenli
            olduğu garanti edilemez.
          </p>

          <h4 className="mt-4">6) Haklarınız</h4>
          <p>
            Uygulanabilir mevzuat kapsamında; verilerinize erişim, düzeltme,
            silme, işlemeyi kısıtlama ve itiraz gibi haklara sahip olabilirsiniz.
          </p>

          <h4 className="mt-4">7) Değişiklikler</h4>
          <p>
            Bu politika zaman zaman güncellenebilir. Güncellemeler Portal’da
            yayımlandığı tarihten itibaren geçerli olur.
          </p>
        </CardBody>
      </Card>
    </Col>
  );
};

export default PrivacyPolicy;
